<template>
  <div id="basic_detail">
    <el-form
         label-width="120px"
         label-position	="left"
        >
   <el-row :gutter="10">
      <el-col :md="12" :lg="12" :xl="12">
          <div class="tips">
            <i class="el-icon-info"></i> 基础信息
          </div>
           <el-form-item label="头像" >
            <el-avatar :size="90" shape="square" fit="contain" :src="file"></el-avatar>
          </el-form-item>
          <el-form-item label="姓名：" >
            {{datalist.name}}
          </el-form-item>
            <el-form-item label="性别：" >
           <i class="el-icon-male"  style="color:rgb(66,126,188)" v-if="datalist.gender=='男'"></i> 
            <i class="el-icon-female"  style="color:rgb(238,73,152)" v-if="datalist.gender=='女'"></i> {{datalist.gender}}
          </el-form-item>
            <el-form-item label="手机号" >
            {{datalist.mobile}}
          </el-form-item>
      </el-col>
       <el-col :md="12" :lg="12" :xl="12">
          <div class="tips">
            <i class="el-icon-info"></i> 工作信息
          </div>
        
          <el-form-item label="员工卡号：" >
            {{datalist.card}}
          </el-form-item>
            <el-form-item label="员工职位：" >
            {{datalist.position}}
          </el-form-item>

            <el-form-item label="状态：" >
            {{datalist.status}}
          </el-form-item>
          <el-form-item label="创建时间：" >
            {{datalist.created_at}}
          </el-form-item>

          
      </el-col>
  
</el-row>
    </el-form>
    <!-- <div class="top_div_detail">
      <el-row class="border_datail_as">
        <el-col :span="6">
          <div class="detail_purple_a toHeight">
            <div class="contents_h">姓名</div>
          </div>
        </el-col>
        <el-col :span="18" class="detail_purple_b toHeight">
          <div>{{datalist.name}}</div>
          <img class="detail_purple_b_img" :src="file" alt />
        </el-col>
      </el-row>
      <el-row class="border_datail_as">
        <el-col :span="6" class>
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">性别</div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{ datalist.gender}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="border_datail_as">
        <el-col :span="6" class>
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">手机</div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.mobile}}</div>
          </div>
        </el-col>
      </el-row>
       <el-row class="border_datail_as">
        <el-col :span="6" class>
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">员工卡号</div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.card}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="border_datail_as">
        <el-col :span="6" class>
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">员工职位</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.position}}</div>
          </div>
        </el-col>
        <el-col :span="6" class>
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">状态</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.status}}</div>
          </div>
        </el-col>
      </el-row>

      <el-row class="border_datail_as border_datail_end">
        <el-col :span="6">
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">创建时间</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.created_at}}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="detail_purple_a centerHeight">
            <div class="contents_h">修改时间</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="detail_purple_b centerHeight">
            <div class="contents_h">{{datalist.updated_at}}</div>
          </div>
        </el-col>
      </el-row>
      <el-button class="go_border_datail" @click="gobasic_insert">返回</el-button>
    </div> -->
  </div>
</template>
<script>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      datalist: {},
      file: '',
    };
  },
  methods: {
    gobasic_insert() {
      this.$router.go(-1);
    },
    getList() {
      // this.listloading = true;
      const id = this.$route.params.id;
      const url = this.$userList.user_semployee_new + '/' + id;
      this.$http.get(url).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.file = res.data.image;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.datalist = res.data;
        } else {
          //res.message && this.$alert(res.message);
        }
        console.log(this.fileList, '????');
      });
    },
  },
  created() {
    this.getList();
    this.$root.setheadName();
  },
};
</script>

<style >
.tips{
  color: #409EFF;
  margin-bottom: 20px;
  margin-top: 20px;
}
#basic_detail {
  /* width: 100%; */
  height: 100%;
  position: relative;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 30px;

}
/* 

.top_div_details {
  width: auto;
}
.top_div_detail {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
}
.border_datail_as {
  border-left: solid 1px #e8e8e8;
  border-top: solid 1px #e8e8e8;
}
.border_datail_end {
  border-bottom: solid 1px #e8e8e8;
}
.detail_purple_a {
  background: #fafafa;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  padding-left: 20px;
  border-right: solid 1px #e8e8e8;
}
.detail_purple_b {
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  border-right: solid 1px #e8e8e8;
  padding-left: 20px;
  font-size: 14px;
  position: relative;
}
.detail_purple_b_img {
  width: 100px;
  height: 120px;
  background: cornflowerblue;
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  border: solid 5px #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.toHeight {
  height: 162px;
  line-height: 162px;
}
.centerHeight {
  height: 54px;
  line-height: 54px;
}
.go_border_datail {
  margin-top: 20px;
  position: relative;
  left: 50%;
} */
</style>


